<template>
  <v-dialog v-model="dialog"
            max-width="800px"
            scrollable>
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator"
            :on="on"
            :attrs="attrs"
            :openDialog="openDialog">
        <!-- Default activator if no custom one is provided -->
        <v-btn v-bind="attrs"
               v-on="on"
               x-small
               @click="openDialog">
          <v-icon small>
            fal fa-fw fa-image
          </v-icon>
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title>
        {{ template.name }}
      </v-card-title>
      <v-card-subtitle class="pb-1">
        {{ template.subject }}
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <template v-if="loading">
          <div class="d-flex justify-center align-center text-body-1 py-2">
            <v-progress-circular size="32"
                                 color="primary"
                                 indeterminate
                                 class="mr-2">
            </v-progress-circular>
            <div>
              Rendering
            </div>
          </div>
        </template>
        <template v-else-if="image?.url">
          <v-img :src="image.url"
                 max-width="800"
                 contain
                 alt="Thumbnail"/>
        </template>
      </v-card-text>
      <ErrorAlert :error="error">
      </ErrorAlert>
    </v-card>
  </v-dialog>
</template>
<script>
import {find} from 'lodash';
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import ErrorAlert from '../../../components/ErrorAlert.vue';

export default {
  components: {ErrorAlert},
  props: {
    template: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      dialog: false,
      error: null,
      images: [],
      loading: false,
    }
  },
  computed: {
    image() {
      const width = 800;
      if (this.images.length > 0) {
        return find(this.images, i => i.width === width);
      }
      return null;
    },
  },
  methods: {
    async fetchData() {
      this.error = null;
      console.log('ShareTemplateImageDialog: fetchData');
      try {
        this.loading = true;
        this.images = await shareTemplateService.getImages(this.template.id);
      } catch (e) {
        this.error = e;
        console.log(`Error fetching template ${this.template.id}:`, e.message);
      } finally {
        this.loading = false;
      }
    },
    openDialog() {
      this.dialog = true;
      this.fetchData();
    }
  }
}
</script>
